import { createUIHeadingMaker } from '../createUIHeadingMaker';
export const makeUIHeading1 = createUIHeadingMaker({
  fontSize: '28px',
  lineHeight: '9u',
  letterSpacing: '-0.5px'
});
export const makeUIHeading2 = createUIHeadingMaker({
  fontSize: '22px',
  lineHeight: '7u',
  letterSpacing: '-0.5px'
});
export const makeUIHeading3 = createUIHeadingMaker({
  fontSize: '18px',
  lineHeight: '6u',
  letterSpacing: '-0.5px'
});
export const makeUIHeading4 = createUIHeadingMaker({
  fontSize: '16px',
  lineHeight: '6u',
  letterSpacing: '-0.2px'
});
export const makeUIHeading5 = createUIHeadingMaker({
  fontSize: '14px',
  lineHeight: '5u',
  letterSpacing: '-0.2px'
});
export const makeUIHeading6 = createUIHeadingMaker({
  fontSize: '12px',
  lineHeight: '4u',
  letterSpacing: '0'
});